import { Box, Typography } from '@mui/material';
import { RankingProps } from './PromotionRanking';
import { numberFormat } from '../../../../utils/commonFunc';
import { useTranslation } from 'react-i18next';
import { getPromotionTool } from '@/components/images/base64/PromotionTool';
import { promotionRanking } from '../PromotionObjectMapper';
import { PromotionEventType } from './PromotionDialog';

type PromotionRankingCellProps = {
    eventType: PromotionEventType;
    ranking: RankingProps;
};
export const PromotionRankingCell = (props: PromotionRankingCellProps) => {
    const { t } = useTranslation();
    const isLeaderboard = props.eventType === PromotionEventType.Leaderboard;
    const ranking = props.ranking;
    const first3 = ranking.Rank > 0 && ranking.Rank <= 3;
    const isSelf = ranking.Self;

    const getFontColor = () => {
        return isSelf || ranking.Rank == 1 ? '#ffffff' : '#979797';
    };

    const getBackgroundColor = () => {
        if (isLeaderboard) {
            if (isSelf) {
                return 'rgba(160, 140, 107, 0.50)';
            } else {
                return ranking.Rank % 2 === 0 ? 'none' : 'rgba(0, 0, 0, .2)';
            }
        } else {
            return isSelf ? 'rgba(10, 89, 88, 1)' : 'rgba(0, 0, 0, 0)';
        }
    };

    return (
        <>
            <Box
                className={`ranking-list-item ${isLeaderboard ? 'leaderboard' : ''}`}
                sx={{
                    backgroundColor: getBackgroundColor(),
                }}
            >
                <Box
                    className={`ranking-item-rank ${isLeaderboard ? 'leaderboard' : ''}`}
                >
                    {first3 ? (
                        // <BaseImage
                        //     className={`promotion_tool event_no_${ranking.Rank}`}
                        //     scale={1}
                        // />
                        <Box>
                            {getPromotionTool(
                                promotionRanking[
                                    isLeaderboard
                                        ? `event_leaderboard_no_${ranking.Rank}`
                                        : `event_no_${ranking.Rank}`
                                ]
                            )}
                        </Box>
                    ) : (
                        <Typography
                            sx={{
                                minWidth: '48px',
                                minHeight: '48px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontSize: '20px',
                                color: getFontColor(),
                            }}
                        >
                            {ranking.Rank.toString()}
                        </Typography>
                    )}
                </Box>
                <Typography
                    className={`ranking-item-player ${isLeaderboard ? 'leaderboard' : ''}`}
                    sx={{
                        color: getFontColor(),
                    }}
                >
                    {isSelf ? t('system.you') : ranking.Username}
                </Typography>
                <Typography
                    className={`ranking-item-amount ${isLeaderboard ? 'leaderboard' : ''}`}
                    sx={{
                        color: getFontColor(),
                    }}
                >
                    {numberFormat(ranking.WinAmount / 100)}
                </Typography>
            </Box>
            {!ranking.LastRank && (
                <Box
                    className={`ranking-list-item-bottom ${isLeaderboard ? 'leaderboard' : ''}`}
                />
            )}
        </>
    );
};
